/**
*
* ArchiveIndex
*
*/

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { pick } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import { Alert, Card } from 'react-bootstrap';
import Spinner from 'components/Spinner/index.jsx';
import DynamicListGroup from 'components/SideMenu/DynamicListGroup/index.jsx';
import messages from './messages.js';
import useArchive from './useArchive.js';

const CardBody = styled(Card.Body)`
  .list-group-item {
    margin-bottom: 0.5rem;
  }
`;

function ArchiveIndex(props) {
  const { setMeta } = props;
  const data = useArchive();
  useEffect(() => {
    setMeta({
      ...pick(messages, ['title', 'description']),
      pageTitle: messages.title,
      width: '640px',
    });
  }, []);
  if (data.loading) {
    return <Spinner />;
  }
  return (
    <Card>
      <CardBody>
        <p className="text-muted"><FormattedMessage {...messages.intro} /></p>
        {data.list.length === 0
          ? <Alert variant="info"><FormattedMessage {...messages.empty} /></Alert>
          : (
            <DynamicListGroup
              data={data}
              link="/archive/:id"
              group
            />
          )}
      </CardBody>
    </Card>
  );
}

ArchiveIndex.propTypes = {
  setMeta: PropTypes.func,
};

export default ArchiveIndex;
